import { browser } from "$app/environment";
import { getTicketOrderData } from "$lib/utilities/ticketOrder.js";
import { datadogLogs } from "@datadog/browser-logs";

export async function load(event) {
  // Todo: for UAT, Panama requested we pull in from the /visit/getting-here page instead of W&C's hardcoded mock info... but really this is hacky and brittle. We should find a more manageable way for content to modify this. It's ugly.
  let orderIdsParam;
  let orderIds;
  try {
    if (event.url.origin === "http://sveltekit-prerender") {
      return {
        entry: event.data.entry,
        ipls: event.data.ipls,
        orderData: {},
        isLoading: true,
        orderIds: null
      };
    }
    orderIdsParam = event.url.searchParams.get("orderIds");
    if (!orderIdsParam) {
      // eslint-disable-next-line no-console
      console.log("live page load, no ids");
      return {
        entry: event.data.entry,
        ipls: event.data.ipls,
        orderData: {},
        isLoading: false,
        orderIds: null
      };
    } else {
      // eslint-disable-next-line no-console
      console.log("live page load, w ids");
      // eslint-disable-next-line no-console
      console.time("ticketOrderCall");
      const startTime = performance.now();

      orderIds = orderIdsParam.split(",");
      const orderData = orderIds ? await getTicketOrderData(orderIds) : [];
      // eslint-disable-next-line no-console
      console.timeEnd("ticketOrderCall");
      const endTime = performance.now();
      if (browser) {
        datadogLogs.logger.info(`ticketOrderCall elapsed time: ${endTime - startTime}ms`);
      }
      return {
        entry: event.data.entry,
        ipls: event.data.ipls,
        orderData,
        isLoading: false,
        orderIds
      };
    }
  } catch (err) {
    console.error("CONFIRMATION PAGE ERROR", err);
    return {
      entry: event.data.entry,
      ipls: event.data.ipls,
      orderData: {},
      isLoading: false,
      orderIds
    };
  }
}
